import { translator } from '@/i18n'
import { commonMessages } from '@/i18n/messages/common'

/**
 * The API's placeholder for a row with no project: several queries `coalesce(name,
 * '(no project)')`. It is UI text that happens to travel as data, so it is translated here at the
 * edge; every real project name passes through unchanged.
 */
export const NO_PROJECT_SENTINEL = '(no project)'

export function projectName(name: string | null | undefined): string {
  return !name || name === NO_PROJECT_SENTINEL ? translator(commonMessages)('noProject') : name
}
